<template>
  <Card class="page-patientSummary">
    <div style="margin-bottom: 15px;text-align: right">
      <el-button type="primary" round @click="add">新增摘要</el-button>
    </div>
    <Table :columns="columns" :data="dataSource" :loading="loading">
      <template slot-scope="{ row }" slot="action">
        <el-popconfirm title="确定删除该摘要吗？" @confirm="remove(row)">
          <el-button slot="reference" type="text" class="error">删除</el-button>
        </el-popconfirm>
      </template>
    </Table>
    <div style="margin-top: 16px; text-align: right">
      <Page
        :transfer="true"
        :total="total"
        :current="page"
        :page-size="size"
        :page-size-opts="sizes"
        :show-total="true"
        :show-elevator="true"
        :show-sizer="true"
        @on-change="onCurrentChange"
        @on-page-size-change="onSizeChange"
      />
    </div>
    <Modal
      v-model="show"
      :mask-closable="false"
      width="500"
      @on-cancel="cancelModal"
    >
      <div slot="header" style="text-align: center">
        <span>新增摘要</span>
      </div>
      <Form
        ref="formValidate"
        :model="cur"
        :rules="rules"
        :label-width="150"
        label-position="right"
        style="margin-left: -40px;margin-right: 40px"
      >
        <FormItem label="摘要名称" prop="name">
          <Input
            v-model.trim="cur.name"
            :maxlength="30"
            type="text"
            placeholder="请填写摘要名称"
          ></Input>
        </FormItem>

        <FormItem label="表单" prop="bind_code">
          <Input
            v-model="cur.bind_code"
            placeholder="请选择绑定表单"
            @on-focus="showModal1"
          ></Input>
        </FormItem>
        <FormItem label="趋势类型" required prop="trend_type">
          <Select v-model="cur.trend_type">
            <Option :key="0" :value="0">分值</Option>
            <Option :key="1" :value="1">答案</Option>
          </Select>
        </FormItem>
        <FormItem v-if="cur.bind_code && cur.trend_type === 1" label="趋势编码" prop="trend_code"
          :rules="{required: true, message: '请选择趋势编码', trigger: 'change'}">
          <Select v-model="cur.trend_code" :label-in-value="true" placeholder="请选择趋势编码" @on-change="handleChange">
            <Option
              v-for="it in question"
              :value="it.value.id"
              :key="it.value.id"
              >{{ questionType(it.value) }}</Option
            >
          </Select>
        </FormItem>
        <FormItem label="顺序" prop="order">
          <InputNumber
            v-model.trim="cur.order"
            :min="-999"
            :max="999"
            :activeChange="false"
            style="width: 100%"
            type="number"
            placeholder="请填写摘要顺序"
          ></InputNumber>
        </FormItem>
      </Form>
      <div slot="footer" style="text-align: center">
        <el-button type="info" round @click="cancel">取消</el-button>
        <el-button
          type="primary"
          round
          :loading="modalLoading"
          @click="save"
          >保存</el-button
        >
      </div>
    </Modal>
    <questionModal
      :isModal="isModal"
      :category_id="3"
      @save="saveModal1"
      @cancel="cancelModal1"
    ></questionModal>
  </Card>
</template>
<script>
import questionModal from "../../common/questionModal.vue";
import {
  getModuleSummaryListApi,
  addModuleSummaryApi,
  deleteModuleSummaryApi,
} from "../../../api/config";
import { mapGetters } from "vuex";
export default {
  components: {
    questionModal,
  },
  props: {
    configType: {
      type: String | Number,
      default: "",
    },
  },
  data() {
    return {
      id: "",
      name: "",
      columns: [
        {
          title: "摘要名称",
          key: "name",
          align: "center",
          width: 150,
        },
        // {
        //   title: "病种id",
        //   key: "disease_id",
        // },
        {
          title: "表单id",
          align: "center",
          key: "bind_code",
        },
        {
          title: "趋势编码",
          align: "center",
          key: "trend_code",
        },
        {
          title: "趋势类型",
          align: "center",
          key: "trend_type",
          width: 150,
          render: (h, props) => {
            return h("div", props.row.trend_type == 0 ? "分值" : "答案");
          },
        },
        {
          title: "操作",
          align: "center",
          key: "action",
          width: 80,
          slot: "action",
        },
      ],
      dataSource: [],
      cur: {
        name: "",
        disease_id: "",
        disease_name: "",
        bind_name: "",
        bind_code: "",
        trend_type: 0,
        trend_code: "",
        trend_name: "",
        category: 0,
      },
      rules: {
        name: [
          {
            required: true,
            message: "请填写摘要名称",
            trigger: "blur",
          },
          { required: true, message: "请填写摘要名称", trigger: "change" },
          // {
          //   pattern: /^[\u4e00-\u9fa5_a-zA-Z0-9]+$/, message: "请输入由中英文、数字以及下划线组成的摘要名称", trigger: "blur"
          // },
          // {
          //   pattern: /^[\u4e00-\u9fa5_a-zA-Z0-9]+$/, message: "请输入由中英文、数字以及下划线组成的摘要名称",trigger: "change"
          // },
        ],
        order: [
          {
            type: "number",
            required: true,
            message: "请填写摘要顺序",
            trigger: "blur",
          },
        ],
        trend_type: [
          {
            type: "number",
            required: true,
            message: "请选择趋势类型",
            trigger: "blur",
          },
        ],
        bind_code: [
          {
            required: true,
            message: "请选择绑定表单",
            trigger: "blur",
          },
          {
            required: true,
            message: "请选择绑定表单",
            trigger: "change",
          },
        ]
      },
      read: false,
      loading: true,
      show: false,
      modalLoading: false,
      isModal: false,
      question: [],
      page: 1,
      size: 10,
      total: 0,
      sizes: [10, 20, 30, 40, 50],
    };
  },
  computed: {
    ...mapGetters(["shift"]),
  },
  methods: {
    handleChange(item) {
      this.cur.trend_name = item.label
    },
    questionType(type) {
      let res;
      if (type.multipleChoiceAttribute) {
        res = type.multipleChoiceAttribute.name;
      } else if (type.singleChoiceAttribute) {
        res = type.singleChoiceAttribute.name;
      } else if (type.singleLineTextAttribute) {
        res = type.singleLineTextAttribute.name;
      } else if (type.fillInBlanksAttribute) {
        res = type.fillInBlanksAttribute.name;
      } else if (type.digitalAttribute) {
        res = type.digitalAttribute.name
      } else if (type.scaleAttribute) {
        res = type.scaleAttribute.name
      } else if (type.sliderAttribute) {
        res = type.sliderAttribute.name
      }
      return res;
    },
    showModal1() {
      this.isModal = true;
    },
    saveModal1(data) {
      if (data && data.length) {
        this.cur.bind_name = data[0].questionnaire_name;
        this.cur.bind_code = data[0].questionnaire_id;
        this.cur.trend_code = "";
        this.isModal = false;
        this.getInfo(this.cur.bind_code);
      } else {
        this.$Message.warning("请选择相关内容");
      }
    },
    cancelModal1() {
      this.isModal = false;
    },
    onCurrentChange(current) {
      this.page = current
      this.getList()
    },
    onSizeChange(size) {
      this.size = size
      this.getList()
    },
    getList() {
      this.loading = true
      const { page, size } = this;
      getModuleSummaryListApi({page, size, type: this.configType, category: 0}).then((res) => {
        this.loading = false
        if (res.code === 0) {
          this.dataSource = res.data;
          this.total = res['x-total-count'] || res.data.length
          if (this.total && !this.dataSource.length && this.page > 1) {
            this.page = this.page - 1
            this.getList()
          }
        } else {
          this.$Message.error(res.message);
        }
      }).catch(() => this.loading = false)
    },
    getInfo(id) {
      this.$utils.caringRequest({
        method: "GET",
        url: this.$utils.getInterface("QUESTIONNAIRE") + "/" + id,
        headers: {
          "content-type": "application/json",
        },
        surplusHeader: true,
        success: (res) => {
          if (res.code === 0) {
            const arr = [];
            res.data.questions.forEach(function (v) {
              if (
                v.type == "SingleChoiceQuestion" ||
                v.type == "MultipleChoiceQuestion" ||
                v.type == "SingleLineTextQuestion" ||
                v.type == "FillInBlankQuestion"||
                v.type == 'DigitalQuestion' ||
                v.type == "ScaleQuestion" ||
                v.type == "SliderQuestion"
              ) {
                arr.push(v);
              }
            });
            this.question = arr;
          } else {
            this.$Message.error(res.message);
          }
        },
      });
    },
    add() {
      this.cur = {
        name: "",
        disease_id: this.shift.disease_id,
        disease_name: this.shift.disease_name,
        bind_name: "",
        bind_code: "",
        trend_type: 0,
        trend_code: "",
        category: 0,
        type: this.configType,
        order: 1,
      };
      this.showModal();
    },
    readRow(row) {
      this.cur = JSON.parse(JSON.stringify(row));
      this.read = true;
      this.showModal();
    },
    remove(row) {
      deleteModuleSummaryApi(row.id).then((res) => {
        if (res.code === 0) {
          this.$Message.success("删除成功");
          this.getList();
        } else {
          this.$Message.error(res.message);
        }
      });
    },
    showModal() {
      this.show = true;
    },
    cancelModal() {
      this.$refs.formValidate.resetFields();
      this.read = false;
      this.modalLoading = false;
    },
    cancel() {
      this.show = false;
      this.cancelModal();
    },
    save() {
      this.modalLoading = true;
      this.$refs.formValidate.validate((valid) => {
        if (valid) {
          const { cur } = this;
          if (cur.trend_type == 0) {
            cur.trend_code = cur.bind_code;
          }
          addModuleSummaryApi(cur).then((res) => {
            this.modalLoading = false;
            if (res.code === 0) {
              this.show = false;
              this.getList();
            } else {
              this.$Message.error(res.message);
            }
          });
        } else {
          this.modalLoading = false;
        }
      });
    },
  },
};
</script>
<style lang="less">
.page-patientSummary {
  .ivu-table-expanded-cell {
    background: #fff;
  }
  .error {
    color: #f56c6c;
    &:focus,
    &:hover {
      color: #f78989;
    }
  }
}
</style>
